export const environment = {
  production: false,
  supabaseUrl: 'https://sbhldbalhxwmouxrlobt.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNiaGxkYmFsaHh3bW91eHJsb2J0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTA4MTY1OTEsImV4cCI6MjEwNjM5MjU5MX0.NMmRBAiJ2E5i8RJhAREX1xmLkGmAazx4Y-zQk_cVXmU',
  rsvpApiUrl: '',
  posthogKey: 'phc_BhBAjjQjfczxYRg9arrHpuwVMuMgaNvjx2DSD6GBsEin',
  posthogHost: 'https://eu.i.posthog.com',
  appEnv: 'dev',
};
